import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  PersonalDataRequest,
  PersonalDataRequestGenderEnum,
} from "../../orchestrator-api-client";
import { Personal } from "../slices/customer/types/personal.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitPersonalInfo = createAsyncThunk<
  Partial<Personal>,
  Partial<Personal>,
  ThunkApi
>("submitPersonalInfo", async (args, { rejectWithValue }) => {
  try {
    const personalDataRequest: PersonalDataRequest = {
      firstName: args.firstName,
      lastName: args.lastName,
    };
    if (args.gender) {
      personalDataRequest.gender =
        PersonalDataRequestGenderEnum[
          args.gender as PersonalDataRequestGenderEnum
        ];
    }

    await new DataCollectionApi().addPersonalInfo(personalDataRequest);

    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio informazioni personali",
      description:
        "Non siamo riusciti a salvare le tue informazioni personali.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
